<template>
  <div v-if="type !== -1" class="care-card">
    <h1><img src="@/assets/smjh-head-img.png"/></h1>
    <div class="sub-title">全面保障 手机无忧</div>
    <care-card class="card" :care="care" />
    <div class="service-title">
      <div>尊享<span> {{ ((service && service.length) || "0") }} </span>大权益</div>
    </div>
    <div class="process-layout module">
      <div
              class="process"
              v-for="(item, index) in service"
              :key="'service-p-' + index"
      >
        <div class="service-head">
          <div class="ico"><span><img :src="item.icon"/></span></div>
          <div class="name">
            <span>{{ item.name }}</span>
            <span v-if="item.time" class="time">
                {{ " 有效期至" + item.time }}
              </span>
          </div>
          <div class="fill"></div>
          <div class="use-info">
            <span class="num">{{ item.total }}{{ item.unit }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="fill"></div>
    <y-button @click="onButtonClick">{{ getButtonText(status) }}</y-button>
    <normal-alert
      v-model="showAlert"
      title="激活提示"
      subTitle="尊敬的用户"
      :icon="require('../../assets/ic_alert_camera.png')"
      content="请使用购卡手机之外的手机登录本程序，进行无忧卡激活流程，并辅助拍摄购卡手机所需要的各张图片"
      buttonText="开始激活"
      @buttonClick="onButtonClick"
    ></normal-alert>
  </div>
</template>
<script>
import { httpOpen } from "../../scripts/network";
export default {
  name: "CareCard2",
  data() {
    return {
      id: "",
      type: -1,
      audit: 30,
      showAlert: false,
      serviceBase: {
        "1": {
          name: "免费贴膜",
          icon: require("../../assets/ic_sticker.png"),
          type: 1,
          use: 0,
          total: 0,
          unit: "次",
        },
        "2": {
          name: "电池更换",
          icon: require("../../assets/ic_battery.png"),
          type: 2,
          use: 0,
          total: 0,
          unit: "次",
        },
        "3": {
          name: "屏幕更换",
          icon: require("../../assets/ic_screen.png"),
          type: 3,
          use: 0,
          total: 0,
          unit: "次",
        },
        "4": {
          name: "整机质保",
          icon: require("../../assets/ic_insurance.png"),
          type: 4,
          use: 0,
          total: 0,
          unit: "年",
        },
          "5": {
              name: "后壳更换",
              icon: require("../../assets/card-qy-type-5.png"),
              type: 5,
              use: 0,
              total: 0,
              unit: "次",
          }
      },
      service: null,
      care: null,
    };
  },
  created() {
    this.code = this.$route.params.code;
    this.loadDetail();
  },
  methods: {
    async loadDetail() {
      this.$loading.show("正在加载...");
      try {
        const ret = await httpOpen("/WuYouCard/GetCardService", {
          type: "post",
          body: { ActivationCode: this.code },
        });
        this.$loading.hide();
        if (!ret.Status) {
          this.$toast("未找到该卡");
          return;
        }
        this.type = ret.Data.ServiceType;
        this.status = ret.Data.CardStatus;
        this.showAlert = this.status === 0;
        this.service = ret.Data.TypeEquityList.map(this.serviceMapper);
        this.name = ret.Data.ServiceClauseName,
        this.care = this.careCardResultMapper(ret.Data);
        console.log(ret);
      } catch (e) {
        this.$loading.hide();
        console.error(e);
      }
    },
    getButtonText(status) {
      if (status === 0) {
        return "激活卡片";
      } else {
        return "查看卡片";
      }
    },
    onButtonClick() {
      if (this.status === 0) {
        this.$router.push({
          name: "CareActive",
          params: {
            code: this.code,
            type: this.type,
          },
          query:{
              name: this.care.name,
          }
        });
      } else {
        this.$router.push("/care");
      }
    },
    careCardResultMapper(data) {
      return {
        id: data.sysNo,
        type: data.ServiceType,
        name: data.ServiceTypeName,
        single: !data.TypeEquityList || data.TypeEquityList.length <= 1,
      };
    },
    serviceMapper(item) {
      let service = this.serviceBase[item.EquityType];
      if (!service){
          service = { name:item.EquityTypeName, unit:'次' };
      }
      service.type = item.EquityType;
      service.use = item.UseTotalNum;
      service.total = service.type !== 4 ? item.EquityTotalCount : 2;
      return service;
    },
  },
};
</script>

<style lang="less" scoped>
.care-card {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding: 16px;
  box-sizing: border-box;
  background: #f4f4f4 url("~@/assets/care-head-bg.png") 0 0 no-repeat;
  background-size: 100%;
  h1 {
    border: none;
    margin: 30px 0 0 0;
    font-size: 18px;
    color: black;
    font-weight: bold;
    line-height: 20px;
    text-align: center;
    width: 60%;
    margin: 0 auto;
    img{
      max-width: 100%;
      display: inline-block;
    }
  }
  .sub-title {
    font-size: 15px;
    color: #000;
    margin-top: 4px;
    font-weight: 600;
    text-align: center;
  }
  .module{
    background-color: #fff;
    border-radius: 8px;
  }
  .service-title {
    width: 100%;
    color: #2E2E2E;
    font-size: 14px;
    margin: 23px 0 0 8px;
    font-weight: 600;
    span {
      color: #DE4E4A;
    }
  }
  .process-layout {
    font-size: 14px;
    margin-top: 11px;
    .process{
      &:not(:last-child){
        border-bottom: 1px solid #efefef;
      }
    }
    .service-head {
      padding: 18px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-bottom: 8px;
      color: #faddaf;
      align-items: center;
      .ico{
        margin-right: 22px;
        >span{
          display: flex;
          justify-content: center;
          align-items: center;
          width: 36px;
          height: 36px;
          border-radius: 100%;
          background: linear-gradient(325deg,rgba(50,50,50,0.84) 8%, rgba(0,0,0,0.84) 92%);
          text-align: center;
          img{
            width: 15px;
            height: 20px;
          }
        }
      }
      .name{
        display: flex;
        flex-direction: column;
        font-weight: 600;
        color: #000000;
        font-size: 14px;
        .time {
          font-size: 12px;
          color: #333;
          font-weight: normal;
        }
      }
      .use-info {
        color: #8D6D41;
        display: flex;
        flex-direction: column;
        text-align: right;
        .num{
          font-weight: 600;
          font-size: 14px;
        }
      }
    }
    .van-progress {
      background: #414458;
    }
  }
  .card {
    border-radius: 10px;
    display: block;
    margin-top: 40px;
  }
  .fill {
    flex: 1 1;
  }
}
</style>
